import * as Sentry from '@sentry/react';
import React from 'react';
import Button from '../buttons/button';
import {FormattedMessage} from "react-intl";

export const Fallback = (): JSX.Element => (
  <div className="w-full flex flex-col justify-center items-center p-3">
    <h2 className="mb-2">
      <FormattedMessage id="errorFallback.title" />
    </h2>
    <p className="text-12 mb-2">
      <FormattedMessage id="errorFallback.message" />
    </p>
    <p className="text-12 mb-4">
      <FormattedMessage id="errorFallback.description" />
    </p>
    <Button onClick={() => window.location.reload()}>
      <FormattedMessage id="errorFallback.reloadButton" />
    </Button>
  </div>
);

const ErrorBoundary = (props: { children: React.ReactNode }): JSX.Element => {
  return (
    <Sentry.ErrorBoundary
      beforeCapture={(scope) => {
        scope.setTag('location', window.location.pathname);
      }}
      fallback={Fallback}
    >
      {props.children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundary;
